import { useEffect, useRef, useState } from "react";
import { fetchGatewayOnlineStatus } from "service/proqueryService";

type GatewayStatus = {
    isOnline: boolean;
    heartbeat: number | null;
};

const useGatewayStatus = (gatewayIds: string[], refreshRate?: number) => {
    const [statuses, setStatuses] = useState<Record<string, GatewayStatus>>();
    const intervalIdRef = useRef<NodeJS.Timeout | null>(null);

    const filteredGatewayIds = gatewayIds.filter((id) => id); // Filter out empty IDs
    const gatewayIdsStr = JSON.stringify(filteredGatewayIds);

    useEffect(() => {
        const gatewayIds = JSON.parse(gatewayIdsStr) as string[];
        const fetchData = async () => {
            try {
                if (!gatewayIds.length) {
                    setStatuses({});
                    return;
                }

                const onlineStatuses = await fetchGatewayOnlineStatus(
                    gatewayIds
                );
                setStatuses(onlineStatuses);
            } catch {
                // Avoid unhandled promise rejection when polling fails.                
                setStatuses({});
            } finally {
                if (refreshRate) {
                    intervalIdRef.current = setTimeout(
                        fetchData,
                        refreshRate * 1000
                    );
                }
            }
        };

        fetchData();

        return () => {
            if (intervalIdRef.current) {
                clearTimeout(intervalIdRef.current);
            }
        };
    }, [gatewayIdsStr, refreshRate]);

    return statuses;
};

export default useGatewayStatus;
